import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function howClose () {
	document.querySelectorAll('.how-close').forEach((section) => {
		const bar = section.querySelector('.nav-cover-bar');
		if (! bar) return;
		ScrollTrigger.create({
			trigger: section,
			start: 'top top',
			end: 'bottom top',
			onToggle: (self) => bar.classList.toggle('is-fixed', self.isActive),
		});
	});
	ScrollTrigger.refresh();
}
